  import { Component, OnInit, ViewChild } from '@angular/core';
  import {  ConfirmationService, MessageService } from 'primeng/api';
  import { TranslateService } from '@ngx-translate/core';
  
  import { GlobalService } from 'src/app/_services/global.service';
  
  import { ActivatedRoute, Router } from '@angular/router';
  import { GridService } from 'src/app/_services/grid.service';
  
  import { ApiService } from 'src/app/_services/api.service';
  import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

  import {
    ColDef,
    CellEditingStartedEvent,
    GridReadyEvent,
  } from 'ag-grid-community';
  import 'ag-grid-community/dist/styles/ag-grid.css';
  import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
  import 'ag-grid-enterprise';
   
  import * as moment from 'moment';
  
@Component({
  selector: 'app-surveycompilations',
  templateUrl: './surveycompilations.component.html',
  styleUrls: ['./surveycompilations.component.css'],
  providers: [ MessageService,ConfirmationService]
})
export class SurveyCompilationsComponent implements OnInit {
    totalQR:number=20;

    surveyName:string='';
 
    surveyId:number;
  
    columns: ColDef[] = [
      { field: 'id',  
        headerName: '', 
        maxWidth:50,
        cellRenderer: params =>    {   
            if(typeof params.value == 'undefined')
              return '';

              return '<a title="'+'View survey compilation (read only)'+'"><i class="pointer pi pi-eye"></i></a>'; 
        },
        onCellClicked:function(data){ 
          
            _this.router.navigate(['/dashboard/surveys/surveyviewcompilation',data.data.id]);
        }   
        
      },
  

      { field: 'date_time_survey', minWidth:250,headerName: 'Compilation date', valueFormatter: (data) => moment(data.value).format('DD/MM/YYYY HH:mm') },
   
      { field: 'rsa',headerName: 'Residence' , minWidth:250},
      { field: 'id',  
      headerName: '', 
      minWidth:250,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
          return '<a title="'+'Delete survey'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 

          _this.confirmationService.confirm({
            message: 'Attention: do you confirm the delete of this compilation?',
            accept: () => {
              _this.apiService.deleteSurveyCompilation({id:params.data.id}).subscribe(data => {
                _this.addSingle('success', 'Success', 'Compilation deleted');
                _this.load();
              });
            }
          });
      },
      }
    ];
  
    frameworkComponents = {
      checkboxRenderer: CheckboxRenderer
    }
    surveyslist: any[] = [];

    gridApi;
    gridColumnApi;
    defaultColDef = {
      width: 250,
      minWidth: 100,
      sortable:true,
      flex:0
    };
  
   
   
    onGridReady(params: GridReadyEvent) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.showLoadingOverlay();
    }
  
  
    public autoSizeAll(gridColumnApi) {
      const allColumnIds = [];
      gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });
    
      gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  
    onfirstDataRendered(params) {
     this.autoSizeAll(params.columnApi);
    }
  
  
    constructor(
      private router: Router,
      private messageService: MessageService,
      private translate: TranslateService,
      public globalService: GlobalService,
      public gridService: GridService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private confirmationService: ConfirmationService,
    ) { }
  
    
    ngOnInit(): void {
      _this=this;
      this.load();
    }
  
    load(){
      const params: any = {PageSize : 10000};
      params.survey_id=parseInt(this.route.snapshot.paramMap.get('id'));
      this.apiService.get('surveys/listallcompilations',params).subscribe(data => {
        this.surveyslist=data.Result;
        if(this.surveyslist.length>0){
          this.surveyName=this.surveyslist[0].name;
        }
      });
    }
    
    addSingle(sev: string, sum: string, det: string) {
      this.messageService.add({severity: sev, summary: sum, detail: det});
    }
  
    
    
  }
  var _this;
  